// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "UNAIDED BMS ENG MED NIDAGUNDI",
   contact: "+91 9902700999/+91 9901999899 | bmspublicschoolndg@gmail.com",
       socialLinks: {
         instagram: "https://www.instagram.com/",
         whatsapp:  "https://wa.me/yourwhatsapplink",
         youtube:   "https://www.youtube.com/channel/UC0fy5z4q5PBOdi-RRq01gPQ",
         facebook:  "https://www.facebook.com/",
         twitter:   "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
